/**
 * Neutral loading fallback for the StationDataDashboard lazy chunk.
 * Used as the <Suspense> fallback in App.tsx while the SDD bundle loads.
 */
export function SddLoading(): JSX.Element {
  return (
    <div className="sdd-router">
      <div style={{ padding: 20, color: '#666', fontStyle: 'italic' }}>Loading Station Data…</div>
    </div>
  );
}
